import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Icon } from "components/common";
import { DataWell } from "security-app/components/common";
import { Row, Col } from "security-app/components/common/FormBaseStyles";
import { useGetPriorities } from "security-app/hooks/useAssetsAPI";
import MachineDetails from "./MachineDetails";
import GeoInfo from "./GeoInfo";
import CustomFields from "./CustomFields";
import RiskPriorityHeader from "../RiskPriorityHeader";
const Description = styled.p`
  white-space: pre-wrap;
`;
function MachineData({ machineAsset }) {
  var _a, _b;
  const { t } = useTranslation("enterprise_security_assets");
  const operatingSystem = /* @__PURE__ */ new Set();
  machineAsset.vulnerabilities.forEach((vuln) => {
    if (vuln.os) operatingSystem.add(vuln.os);
  });
  const { priorities } = useGetPriorities();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    RiskPriorityHeader,
    {
      riskScore: machineAsset.risk_score_normalized,
      priorityValue: machineAsset.priority,
      priorities
    }
  ), /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Row, { "aria-label": t("machine_data.operating_system_well") }, /* @__PURE__ */ React.createElement(Icon, { name: "computer", type: "regular" }), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("small", null, t("machine_data.operating_system")), /* @__PURE__ */ React.createElement("span", null, [...operatingSystem].join(", ") || /* @__PURE__ */ React.createElement("i", null, t("machine_data.no_operating_system_information")))))), /* @__PURE__ */ React.createElement(MachineDetails, { machineAsset }), /* @__PURE__ */ React.createElement(DataWell, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("small", null, t("machine_data.description")), /* @__PURE__ */ React.createElement(Description, null, machineAsset.details.description || /* @__PURE__ */ React.createElement("i", null, t("machine_data.no_description"))))), /* @__PURE__ */ React.createElement("strong", null, t("machine_data.geo_information")), /* @__PURE__ */ React.createElement(GeoInfo, { geoInfo: (_a = machineAsset.details) == null ? void 0 : _a.geo_info }), /* @__PURE__ */ React.createElement("strong", null, t("machine_data.custom_fields")), /* @__PURE__ */ React.createElement(CustomFields, { customFields: (_b = machineAsset.details) == null ? void 0 : _b.custom_fields }));
}
export default MachineData;
